const SHARED = {
  gold: '#F3C649',
  crimson: '#E5484D',
  emerald: '#2F9E64',
};

const t = (partial) => ({
  onAccent: '#FFFFFF',
  ...SHARED,
  ...partial,
});

export const THEMES = {
  ozel: t({
    id: 'ozel', kind: 'ozel', name: 'Özel', desc: 'Siyah · şarap · kırmızı · altın · krem',
    canvas: '#020100', surface: '#160302', surface2: '#5D0403', surface3: '#3A0504',
    accent: '#C91010', accent2: '#5D0403', gold: '#D89B3C', crimson: '#C91010',
    onAccent: '#F7F0EE', txt: '#F7F0EE', txt2: '#C4B0AA',
    swatches: ['#020100', '#5D0403', '#C91010', '#D89B3C', '#F7F0EE'],
  }),
  obsidian: t({
    id: 'obsidian', kind: 'single', name: 'Obsidian', desc: 'Mevcut cyan — koyu lacivert',
    canvas: '#0A1220', surface: '#101B2D', surface2: '#16263D', surface3: '#1E3251',
    accent: '#2FB4F9', accent2: '#0E9DE5', txt: '#F1F5F9', txt2: '#94A3B8',
  }),
  ember: t({
    id: 'ember', kind: 'single', name: 'Ember', desc: 'Sıcak kömür + kehribar',
    canvas: '#140E0C', surface: '#1C1410', surface2: '#2A1C14', surface3: '#3D281C',
    accent: '#F5A524', accent2: '#D4850F', txt: '#F8F1E8', txt2: '#B8A898',
  }),
  royal: t({
    id: 'royal', kind: 'single', name: 'Royal', desc: 'Gece moru + violet',
    canvas: '#0C0A16', surface: '#141022', surface2: '#1C1830', surface3: '#2A2448',
    accent: '#A78BFA', accent2: '#7C5CFC', txt: '#F3F0FF', txt2: '#A8A0C0',
  }),
  jade: t({
    id: 'jade', kind: 'single', name: 'Jade', desc: 'Orman koyusu + mint',
    canvas: '#071411', surface: '#0C1C18', surface2: '#122824', surface3: '#1A3830',
    accent: '#2EE6A6', accent2: '#12C98A', txt: '#ECFDF6', txt2: '#8AADA0',
  }),
  ruby: t({
    id: 'ruby', kind: 'single', name: 'Ruby', desc: 'Koyu gül + rose',
    canvas: '#14080C', surface: '#1C0E14', surface2: '#2A141C', surface3: '#3A1C28',
    accent: '#FB7185', accent2: '#E11D5A', txt: '#FFF1F3', txt2: '#C4A0A8',
  }),
  ice: t({
    id: 'ice', kind: 'single', name: 'Ice', desc: 'Çelik slate + buz mavisi',
    canvas: '#0B1218', surface: '#121C26', surface2: '#1A2836', surface3: '#243848',
    accent: '#7DD3FC', accent2: '#0EA5E9', txt: '#F0F9FF', txt2: '#94A8B8',
  }),
  noir: t({
    id: 'noir', kind: 'single', name: 'Noir', desc: 'Mat siyah',
    canvas: '#080808', surface: '#111111', surface2: '#1A1A1A', surface3: '#262626',
    accent: '#E8E8E8', accent2: '#B0B0B0', gold: '#D4AF37', onAccent: '#111111',
    txt: '#F2F2F2', txt2: '#8A8A8A',
  }),
  steel: t({
    id: 'steel', kind: 'single', name: 'Steel', desc: 'Grafit gri',
    canvas: '#101214', surface: '#181A1C', surface2: '#222628', surface3: '#32363A',
    accent: '#C5C8D0', accent2: '#9BA0AA', onAccent: '#121416',
    txt: '#F2F2F4', txt2: '#8C9096',
  }),
  marine: t({
    id: 'marine', kind: 'single', name: 'Marine', desc: 'Lacivert',
    canvas: '#070B14', surface: '#0C1220', surface2: '#131B2C', surface3: '#1C2740',
    accent: '#3D6BB3', accent2: '#2A4F8A', txt: '#EEF1F6', txt2: '#8B93A8',
  }),
  cinder: t({
    id: 'cinder', kind: 'single', name: 'Cinder', desc: 'Turuncu',
    canvas: '#140E0A', surface: '#1C1410', surface2: '#2A1C12', surface3: '#3A2618',
    accent: '#E85D04', accent2: '#C44D00', gold: '#F0A202', txt: '#F6F3EF', txt2: '#B8A090',
  }),
  brass: t({
    id: 'brass', kind: 'single', name: 'Brass', desc: 'Sarı',
    canvas: '#12100A', surface: '#1A1810', surface2: '#262210', surface3: '#363018',
    accent: '#E8B800', accent2: '#C49A00', gold: '#E8B800', onAccent: '#141000',
    txt: '#F7F6F0', txt2: '#A09880',
  }),
  noirflame: t({
    id: 'noirflame', kind: 'dual', name: 'Siyah · Turuncu', desc: 'Karbon siyah, yanık turuncu',
    canvas: '#090909', surface: '#121212', surface2: '#1C1C1C', surface3: '#2A2A2A',
    accent: '#E85D04', accent2: '#C44D00', gold: '#F0A202', onAccent: '#140800',
    txt: '#F6F3EF', txt2: '#9A9088',
  }),
  noirgold: t({
    id: 'noirgold', kind: 'dual', name: 'Siyah · Altın', desc: 'Mat siyah, klasik altın',
    canvas: '#070707', surface: '#111111', surface2: '#1A1A1A', surface3: '#262626',
    accent: '#C6A035', accent2: '#A68628', gold: '#D4AF37', onAccent: '#120E06',
    txt: '#F5F3EC', txt2: '#8A8680',
  }),
  inkyellow: t({
    id: 'inkyellow', kind: 'dual', name: 'Siyah · Sarı', desc: 'Siyah zemin, taksi sarısı',
    canvas: '#080808', surface: '#121212', surface2: '#1B1B1B', surface3: '#2A2A2A',
    accent: '#E8B800', accent2: '#C49A00', gold: '#E8B800', onAccent: '#141000',
    txt: '#F7F6F0', txt2: '#8F8C80',
  }),
  navygold: t({
    id: 'navygold', kind: 'dual', name: 'Lacivert · Altın', desc: 'Gece laciverti, fırça altın',
    canvas: '#070B14', surface: '#0C1220', surface2: '#131B2C', surface3: '#1C2740',
    accent: '#C9A227', accent2: '#A6861C', gold: '#D4AF37', onAccent: '#120E06',
    txt: '#F3F1EA', txt2: '#8B93A8',
  }),
  navyflame: t({
    id: 'navyflame', kind: 'dual', name: 'Lacivert · Turuncu', desc: 'Derin lacivert, yanık turuncu',
    canvas: '#070A12', surface: '#0C1220', surface2: '#151E30', surface3: '#222C44',
    accent: '#E56B1A', accent2: '#C45A14', gold: '#E8A317', onAccent: '#140800',
    txt: '#F4F2EE', txt2: '#8E97AB',
  }),
  steelflame: t({
    id: 'steelflame', kind: 'dual', name: 'Gri · Turuncu', desc: 'Çelik gri, amber turuncu',
    canvas: '#101214', surface: '#181A1C', surface2: '#222628', surface3: '#32363A',
    accent: '#E07020', accent2: '#C45C18', gold: '#E8A317', onAccent: '#140800',
    txt: '#F3F2F0', txt2: '#93989E',
  }),
  carbon: t({
    id: 'carbon', kind: 'dual', name: 'Siyah · Gri', desc: 'Karbon siyah, graphite çizgi',
    canvas: '#050505', surface: '#0E0E0E', surface2: '#171717', surface3: '#242424',
    accent: '#A8A8A8', accent2: '#7A7A7A', gold: '#C9A227', onAccent: '#0A0A0A',
    txt: '#F0F0F0', txt2: '#8A8A8A',
  }),
};

export const THEME_LIST = Object.values(THEMES);
export const THEME_IDS = Object.keys(THEMES);
export const DEFAULT_THEME = 'obsidian';
export const THEME_GROUPS = [
  { key: 'ozel', label: 'Özel' },
  { key: 'single', label: 'Tek renk' },
  { key: 'dual', label: 'Çift renk' },
];

const hexToRgb = (hex) => {
  const n = hex.replace('#', '');
  const v = parseInt(n, 16);
  return `${(v >> 16) & 255} ${(v >> 8) & 255} ${v & 255}`;
};

const hexToHsl = (hex) => {
  const n = hex.replace('#', '');
  let r = parseInt(n.slice(0, 2), 16) / 255;
  let g = parseInt(n.slice(2, 4), 16) / 255;
  let b = parseInt(n.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = 0;
  let s = 0;
  const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
    else if (max === g) h = ((b - r) / d + 2) / 6;
    else h = ((r - g) / d + 4) / 6;
  }
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
};

let themeChannel;
try { themeChannel = new BroadcastChannel('bh-theme'); } catch { themeChannel = null; }

export const applyTheme = (id, { broadcast = true } = {}) => {
  const theme = THEMES[id] || THEMES[DEFAULT_THEME];
  const root = document.documentElement;
  const set = (k, v) => root.style.setProperty(k, v);
  const onAccent = theme.onAccent || '#FFFFFF';
  set('--bh-canvas', theme.canvas);
  set('--bh-canvas-rgb', hexToRgb(theme.canvas));
  set('--bh-surface', theme.surface);
  set('--bh-surface-rgb', hexToRgb(theme.surface));
  set('--bh-surface-2', theme.surface2);
  set('--bh-surface-2-rgb', hexToRgb(theme.surface2));
  set('--bh-surface-3', theme.surface3);
  set('--bh-surface-3-rgb', hexToRgb(theme.surface3));
  set('--bh-accent', theme.accent);
  set('--bh-accent-rgb', hexToRgb(theme.accent));
  set('--bh-accent-2', theme.accent2);
  set('--bh-accent-2-rgb', hexToRgb(theme.accent2));
  set('--bh-gold', theme.gold);
  set('--bh-gold-rgb', hexToRgb(theme.gold));
  set('--bh-crimson', theme.crimson);
  set('--bh-crimson-rgb', hexToRgb(theme.crimson));
  set('--bh-emerald', theme.emerald);
  set('--bh-emerald-rgb', hexToRgb(theme.emerald));
  set('--bh-txt', theme.txt);
  set('--bh-txt-rgb', hexToRgb(theme.txt));
  set('--bh-txt-2', theme.txt2);
  set('--bh-txt-2-rgb', hexToRgb(theme.txt2));
  set('--bh-on-accent', onAccent);
  set('--bh-on-accent-rgb', hexToRgb(onAccent));
  set('--background', hexToHsl(theme.canvas));
  set('--foreground', hexToHsl(theme.txt));
  set('--card', hexToHsl(theme.surface));
  set('--card-foreground', hexToHsl(theme.txt));
  set('--popover', hexToHsl(theme.surface));
  set('--popover-foreground', hexToHsl(theme.txt));
  set('--primary', hexToHsl(theme.accent));
  set('--primary-foreground', hexToHsl(onAccent));
  set('--secondary', hexToHsl(theme.surface2));
  set('--secondary-foreground', hexToHsl(theme.txt));
  set('--muted', hexToHsl(theme.surface3));
  set('--muted-foreground', hexToHsl(theme.txt2));
  set('--accent', hexToHsl(theme.accent));
  set('--accent-foreground', hexToHsl(onAccent));
  set('--destructive', hexToHsl(theme.crimson));
  set('--border', hexToHsl(theme.surface3));
  set('--input', hexToHsl(theme.surface3));
  set('--ring', hexToHsl(theme.accent));
  root.dataset.theme = theme.id;
  try {
    const themeMeta = document.querySelector('meta[name="theme-color"]');
    if (themeMeta) themeMeta.setAttribute('content', theme.canvas);
  } catch { /* ignore */ }
  try {
    const host = (typeof window !== 'undefined' ? window.location.hostname : '').replace(/^www\./, '').toLowerCase();
    if (host) {
      localStorage.setItem('bh_theme:' + host, theme.id);
      const keys = ['--bh-canvas','--bh-canvas-rgb','--bh-surface','--bh-surface-rgb','--bh-surface-2','--bh-surface-2-rgb','--bh-surface-3','--bh-surface-3-rgb','--bh-accent','--bh-accent-rgb','--bh-accent-2','--bh-accent-2-rgb','--bh-gold','--bh-gold-rgb','--bh-crimson','--bh-crimson-rgb','--bh-emerald','--bh-emerald-rgb','--bh-txt','--bh-txt-rgb','--bh-txt-2','--bh-txt-2-rgb','--bh-on-accent','--bh-on-accent-rgb'];
      const snap = {};
      keys.forEach((k) => { snap[k] = root.style.getPropertyValue(k); });
      localStorage.setItem('bh_theme_css:' + host, JSON.stringify(snap));
    }
  } catch { /* ignore */ }
  if (broadcast && themeChannel) {
    try {
      const host = (typeof window !== 'undefined' ? window.location.hostname : '');
      themeChannel.postMessage({ id: theme.id, host });
    } catch { /* ignore */ }
  }
};

if (themeChannel) {
  themeChannel.onmessage = (e) => {
    if (!e.data?.id) return;
    const host = typeof window !== 'undefined' ? window.location.hostname : '';
    if (e.data.host && e.data.host !== host) return;
    applyTheme(e.data.id, { broadcast: false });
  };
}

try {
  const host = (typeof window !== 'undefined' ? window.location.hostname : '').replace(/^www\./, '').toLowerCase();
  const primary = host === 'localhost' || host === '127.0.0.1' || host === 'devrimbey.com';
  if (primary) {
    const cached = (host && localStorage.getItem('bh_theme:' + host)) || localStorage.getItem('bh_theme');
    if (cached && THEMES[cached]) applyTheme(cached, { broadcast: false });
  }
} catch { /* ignore */ }
